import ReactDOM, { flushSync } from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
const reactDomClientNamespace = ReactDOMClient;
const rootsByContainer = new WeakMap();
let isPrintRenderSyncEnabled = false;
export function setPrintRenderSync(enabled) {
    isPrintRenderSyncEnabled = enabled;
}
const SERVER_REACT18_FLAG_KEY = '__enableReact18';
function isReact18EnabledOnServer() {
    return globalThis[SERVER_REACT18_FLAG_KEY] !== false;
}
const RESOLVED_CREATE_ROOT_KEY = '__tsCompatResolvedCreateRoot';
const asFn = (f) => typeof f === 'function' ? f : undefined;
function getCreateRoot() {
    var _a, _b, _c, _d, _e, _f;
    const g = globalThis;
    if (!g[RESOLVED_CREATE_ROOT_KEY]) {
        const lib = (_a = g === null || g === void 0 ? void 0 : g.libs) === null || _a === void 0 ? void 0 : _a.ReactDOMClientLib;
        const fallback = reactDomClientNamespace;
        const createRoot = (_e = (_d = (_b = asFn(lib === null || lib === void 0 ? void 0 : lib.createRoot)) !== null && _b !== void 0 ? _b : asFn((_c = lib === null || lib === void 0 ? void 0 : lib.default) === null || _c === void 0 ? void 0 : _c.createRoot)) !== null && _d !== void 0 ? _d : asFn(fallback === null || fallback === void 0 ? void 0 : fallback.createRoot)) !== null && _e !== void 0 ? _e : asFn((_f = fallback === null || fallback === void 0 ? void 0 : fallback.default) === null || _f === void 0 ? void 0 : _f.createRoot);
        if (createRoot) {
            g[RESOLVED_CREATE_ROOT_KEY] = createRoot;
        }
    }
    return g[RESOLVED_CREATE_ROOT_KEY] || null;
}
function createCompatRoot(container) {
    if (isReact18EnabledOnServer()) {
        const createRoot = getCreateRoot();
        if (createRoot) {
            return createRoot(container);
        }
    }
    return {
        render: node => {
            ReactDOM.render(node, container);
        },
        unmount: () => {
            ReactDOM.unmountComponentAtNode(container);
        },
    };
}
export function renderIntoContainer(node, container, onRendered) {
    let root = rootsByContainer.get(container);
    if (!root) {
        root = createCompatRoot(container);
        rootsByContainer.set(container, root);
    }
    const compatRoot = root;
    const needsSyncCommit = !!onRendered || isPrintRenderSyncEnabled;
    if (isReact18EnabledOnServer() && needsSyncCommit) {
        flushSync(() => compatRoot.render(node));
    }
    else {
        compatRoot.render(node);
    }
    onRendered === null || onRendered === void 0 ? void 0 : onRendered();
}
export function unmountContainer(container) {
    const root = rootsByContainer.get(container);
    if (root) {
        root.unmount();
        rootsByContainer.delete(container);
    }
}
//# sourceMappingURL=react-root.util.js.map